import { handleActions } from "redux-actions";

import { BRAND_CATEGORIES_SUCCESS, BRAND_CATEGORIES_REQUEST, BRAND_CATEGORIES_FAILURE } from "constants/action-types";

const initialState = {};

const brandCategoriesReducer = handleActions(
    {
        [BRAND_CATEGORIES_REQUEST]: (state, { payload }) => {
            return Object.assign({}, state, {
                [payload]: {
                    results: [],
                    isFetching: true,
                    error: undefined,
                },
            });
        },
        [BRAND_CATEGORIES_SUCCESS]: (state, { payload, meta }) => {
            return Object.assign({}, state, {
                [meta.topLevelCategory]: {
                    results: payload,
                    isFetching: false,
                    error: undefined,
                },
            });
        },
        [BRAND_CATEGORIES_FAILURE]: (state, { payload, meta }) => {
            return Object.assign({}, state, {
                [meta.topLevelCategory]: {
                    results: [],
                    isFetching: false,
                    error: payload,
                },
            });
        },
    },
    initialState,
);

export default brandCategoriesReducer;
